import Util from '@/helper/Utility.js';
import CacheHelper from '@/helper/CacheHelper.js';
import ConfigManager from '@/config/ConfigManager.js';

const KEY_COOKIE_DELIVERY = 'BzbsDelivery';
const KEY_COOKIE_SELECTBRANCH = 'BzbsSelectBranch';

export default {
    getCacheDelivery: function () {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        return cache.getCache(KEY_COOKIE_DELIVERY);
    },
    setCacheDelivery: function (delivery) {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        return cache.setCache(KEY_COOKIE_DELIVERY, delivery);
    },
    removeCacheDelivery: function () {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        cache.removeCache(KEY_COOKIE_DELIVERY);
    },
    isDelivery: function() {
        var delivery = this.getCacheDelivery();
        return !Util.isEmptyObject(delivery);
    },
    getTier: function() {
        return this.getCacheDelivery() ? this.getCacheDelivery().category : null;
    },
    getCacheSelectBranch: function () {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        return cache.getCache(KEY_COOKIE_SELECTBRANCH);
    },
    setCacheSelectBranch: function (selectBranch) {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        return cache.setCache(KEY_COOKIE_SELECTBRANCH, selectBranch);
    },
    removeCacheSelectBranch: function () {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        cache.removeCache(KEY_COOKIE_SELECTBRANCH);
    },
}